import { getMixedMediaCapability } from '../../capability/mixedMediaCapability'
import type { MixedMediaCapability } from '../../capability/mixedMediaCapability'
import { isService } from '../../save/metadata'
import { peekComposerStore } from '../composerStore'

const INCAPABLE: MixedMediaCapability = {
  canMixMediaTypes: false,
  canHaveMultipleVideos: false,
}

/**
 * Non-React counterpart to `useMixedMediaCapability`, for legacy Flux code
 * (`ComposerStore.ts`) that cannot use hooks. Reads the capability inputs
 * seeded into the Zustand store by `useMixedMediaCapabilityBridge` and
 * delegates to `getMixedMediaCapability`.
 *
 * `serviceName` comes from a legacy `Draft.service.name`, typed as a plain
 * string; an unrecognized name is safely incapable rather than a thrown
 * error, EXCEPT the channel-less `'omni'` draft — its destination channel
 * isn't chosen yet, so it bypasses the per-network allowlist while still
 * respecting the org-level rollout flag. Likewise, no live composer session
 * (no Zustand store) is treated as incapable rather than thrown — some
 * legacy Flux dispatch paths run without ever mounting a composer session.
 */
export function getMixedMediaCapabilityForService(
  serviceName: string,
): MixedMediaCapability {
  const store = peekComposerStore()
  if (!store) {
    return INCAPABLE
  }

  const { orgEnabled } = store.getState().mixedMediaCapabilityInputs

  if (serviceName === 'omni') {
    return { canMixMediaTypes: orgEnabled, canHaveMultipleVideos: orgEnabled }
  }

  if (!isService(serviceName)) {
    return INCAPABLE
  }

  return getMixedMediaCapability({ orgEnabled, service: serviceName })
}
